import React, {useContext} from 'react';
import LineItem from './LineItem';
import Client from 'shopify-buy';
import { CheckoutsContext, CartContext } from "./products/productsContext"

const client = Client.buildClient({
  domain: 'conecuh-brands.myshopify.com',
  storefrontAccessToken: 'fd73aae121a8110089143a1d450c7b6e'
});


const CartDetails = (props) => {
    const [showCart, setShowCart] = useContext(CartContext)
    const [checkout, setCheckout] = useContext(CheckoutsContext)

    const openCheckout = () =>{
        window.open(checkout.webUrl);
    }
    
    const updateQuantityInCart = (lineItemId, quantity) => {
        const checkoutId = checkout.id
        const lineItemsToUpdate = [{id: lineItemId, quantity: parseInt(quantity, 10)}]
        client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
            setCheckout(res)
        });
    }

    const removeLineItemInCart = (lineItemId) => {
        const checkoutId = checkout.id
        client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
            setCheckout(res)
        });
    }
    
    const handleCloseCart = () => {
        setShowCart(false)
    }

      
    const line_items = checkout.lineItems.map((line_item) => {
      return (
        <LineItem
          updateQuantityInCart={updateQuantityInCart}
          removeLineItemInCart={removeLineItemInCart}
          key={line_item.id.toString()}
          line_item={line_item}
        />
      );
    });


    console.log(checkout)

    return (
      <div className={showCart?"Cart Cart--open":"Cart Cart__close display-none"}>
        <header className="Cart__header">
          <h2>Your cart</h2>
          <button
            onClick={handleCloseCart}
            className="Cart__close">
            ×
          </button>
        </header>
        <ul className="Cart__line-items">
          {line_items}
        </ul>
        <footer className="Cart__footer">
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Subtotal</div>
            <div className="Cart-info__pricing">
              <span className="pricing">$ {checkout.subtotalPrice.amount}</span>
            </div>
          </div>
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Taxes</div>
            <div className="Cart-info__pricing">
              <span className="pricing">$ {checkout.totalTax.amount}</span>
            </div>
          </div>
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Total</div>
            <div className="Cart-info__pricing">
              <span className="pricing">$ {checkout.totalPrice.amount}</span>
            </div>
          </div>
          <button className="Cart__checkout button" onClick={openCheckout}>Checkout</button>
        </footer>
      </div>
    )
  }


export default CartDetails;



// WEBPACK FOOTER //
// ./src/components/CartDetails.js